import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ApolloProvider } from "@apollo/client";
import { client } from "./utils/apollo";
import { BrowserRouter as Router } from "react-router-dom";
import { extendTheme, ThemeConfig, ChakraProvider } from "@chakra-ui/react";
import { AuthProvider } from "./context/AuthContext";
import "@fontsource/roboto";
import "react-tiny-fab/dist/styles.css";
import PublicFooter from "./pages/public/Footer";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
const config: ThemeConfig = {
  initialColorMode: "light",
  // useSystemColorMode: true,
};
const colors = {
  primary: "#22c35e",
};

// 3. extend the theme
const theme = extendTheme({
  config,
  colors,
});

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <Router>
        <ChakraProvider theme={theme}>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ChakraProvider>
      </Router>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
